import { useEffect } from 'react';
import { Resource } from '../../lib/types';
import ResourceCard from '../ResourceCard';

export interface ResourceCardProps {
  resources?: Resource[];
  onRemoveResource?: (resourceId: number) => void;
}

export const ResourceGrid = ({
  resources = [],
  onRemoveResource,
}: ResourceCardProps) => {
  useEffect(() => {
    document.querySelector('.image-library-search-wrapper')?.scrollIntoView();
  }, [resources]);

  return (
    <div className="resources-grid">
      {resources.map((resource: Resource, index: number) => (
        <ResourceCard
          key={`resource-${resource.ref}-${index}`}
          resource={resource}
          onRemoveResource={onRemoveResource}
        />
      ))}
      {resources.length === 0 && (
        <div className="resources-empty">No images found</div>
      )}
    </div>
  );
};
